import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSuitcase: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSuitcase"><Path fillRule="evenodd" clipRule="evenodd" d="M8 2H16V5H21V21H18V22H16V21H8V22H6V21H3V5H8V2ZM10 5H14V4H10V5ZM10 9V17H8V9H10ZM16 9V17H14V9H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSuitcase;
